import { c as _c } from "react-compiler-runtime";
import { useCallback, useMemo } from 'react';
import { useCrmObjectType } from 'framework-listing-lib/internal/providers/CrmObjectTypeListingClientProvider';
import { useHasViews } from 'framework-listing-lib/internal/ViewTabs/hooks/useViewProps';
import { useHasFoldersMode } from 'framework-listing-lib/internal/hooks/useUIMode';
export default function useFolderProps() {
  "use memo";

  const $ = _c(1);
  const {
    folderProps
  } = useCrmObjectType();
  let t0;
  bb0: {
    if (!folderProps) {
      let t1;
      if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {};
        $[0] = t1;
      } else {
        t1 = $[0];
      }
      t0 = t1;
      break bb0;
    }
    t0 = folderProps;
  }
  return t0;
}
export function useHasFoldersTab() {
  "use memo";

  const hasViews = useHasViews();
  const hasFoldersMode = useHasFoldersMode();
  return hasViews && hasFoldersMode;
}
export function useOnSelectFolder() {
  "use memo";

  const $ = _c(2);
  const {
    onSelectFolder
  } = useFolderProps();
  let t0;
  if ($[0] !== onSelectFolder) {
    t0 = crmFolder => {
      if (onSelectFolder) {
        onSelectFolder(crmFolder);
      }
    };
    $[0] = onSelectFolder;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}
export function useHiddenFolderFilter() {
  "use memo";

  const {
    hiddenFilter
  } = useFolderProps();
  return hiddenFilter;
}
export function useHideFolderAssetCount() {
  "use memo";

  const {
    hideFolderAssetCount
  } = useFolderProps();
  return hideFolderAssetCount !== null && hideFolderAssetCount !== void 0 ? hideFolderAssetCount : false;
}